import Service from '@/helpers/service'

export default {

    index(params) {
        return Service().get('warehouse-location/index', {params});
    },
    getWarehouseLocation(params) {
        return Service().get('warehouse-location/get-warehouse-location', {params});
    },
    show(id) {
        return Service().get('warehouse-location/show/'+id);
    },
    create(params) {
        return Service().post('warehouse-location/create', params, {
            headers: {
              'Content-Type': 'multipart/form-data'
            }
        });
    },
    update(id, params) {
        return Service().post('warehouse-location/update/'+id, params, {
            headers: {
              'Content-Type': 'multipart/form-data'
            }
        });
    },
    delete(id) {
        return Service().post('warehouse-location/delete/'+id);
    },
    getFromWarehouseLocation(params) {
        return Service().get('warehouse-location/get-from-warehouse-location', {params});
    },
}